import { render, staticRenderFns } from "./single_reports.vue?vue&type=template&id=6243b6ee"
import script from "./single_reports.vue?vue&type=script&lang=js"
export * from "./single_reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports